import React from "react";

export const RaffleOfflineInstructions = () => (
    <div data-testid="raffle-offline-instructions" className="text-sm text-[#4A5568] mt-3 max-w-md mx-auto space-y-3">
        <p data-testid="raffle-payment-meetup-note">We&apos;ll contact you to arrange a meetup location for your payment. You can also mail cash or a check to:</p>
        <address data-testid="raffle-payment-mailing-address" className="not-italic leading-relaxed text-[#1C252E]">
            <span className="block font-semibold">Reddog Community Foundation Inc.</span>
            <span className="block">PO Box 231</span>
            <span className="block">Frenchtown, MT 59834</span>
        </address>
        <p data-testid="raffle-payment-reference-note" className="text-xs">Make checks payable to Reddog Community Foundation Inc. Include your name and confirmation ID with your payment.</p>
    </div>
);